import React from 'react';
import InputTypesEnum from '../Enums/InputTypesEnum';
import ValidityHelper from '../Helpers/ValidityHelper';
import StoredJsonDataService from '../Services/StoredJsonDataService';
import ColButton from './ColButton';
import ErrorMessage from './ErrorMessage';
import LoadingIcon from './LoadingIcon';
import OverWindow from './OverWindow';
import InputWithClear from './InputComponents/InputWithClear';
import { List, ListItem, ListItemText } from '@mui/material';
import Popup from './popup';

class SaveJsonDataWindow extends React.Component {
  static defaultProps = {
    itemToSave: null,
    saveType: '',
    clickOnCancel: () => {},
    windowText: 'Save Data',
  };

  constructor(props) {
    super(props);
    this.state = {
      existingNames: [],
      loading: true,
      popup: null,
      Name: '',
    };
    this.clickOnSubmit = this.clickOnSubmit.bind(this);
  }

  componentDidMount() {
    this.getExistingNames();
  }

  async getExistingNames() {
    this.setState({ loading: true });
    StoredJsonDataService.getExistingNames(this.props.saveType)
      .then((result) => {
        this.setState({
          existingNames: result.names,
          loading: false,
        });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('SJDW52');
        this.setState({ loading: false });
      });
  }

  clickOnSubmit(e) {
    e.preventDefault();
    if (this.state.existingNames.includes(this.state.Name)) {
      let popup = (
        <Popup
          text={
            <div>
              <p>A file with this name already exists. Do you want to overwrite it?</p>
            </div>
          }
          cancelButtonText='Cancel'
          okButtonText='Ok'
          closePopupFunction={() => this.setState({ popup: null })}
          okPopupFunction={() => {
            this.setState({ popup: null });
            this.saveItem();
          }}
        />
      );
      this.setState({ popup: popup });
    } else {
      this.saveItem();
    }
  }

  saveItem() {
    this.setState({ loading: true });
    StoredJsonDataService.postStoredJsonData(this.state.Name, this.props.saveType, this.props.itemToSave)
      .then((result) => this.props.clickOnCancel())
      .catch((error) => {
        ErrorMessage.SetErrorMessage('SJDW92');
        this.setState({ loading: false });
      });
  }

  renderInputField(fieldName, labelText, colwidth, type, validityCheckerFunction) {
    if (type === undefined) {
      type = InputTypesEnum.Text;
    }
    return (
      <div className={colwidth}>
        <InputWithClear
          fieldName={fieldName}
          labelText={labelText}
          type={type}
          value={this.state[fieldName]}
          onChange={(fieldName, newValue) => this.setState({ [fieldName]: newValue })}
          validityChecker={validityCheckerFunction}
        />
      </div>
    );
  }

  renderFileList() {
    return (
      <div className='p-1 m-1 col'>
        <p className='text-center'>Files</p>
        <List
          className='fixedHeightList'
          dense={true}
          component='div'
          role='list'
        >
          {this.state.existingNames.map((e, index) => {
            return (
              <ListItem
                key={'exf' + index}
                button
                selected={this.state.Name === e}
                onClick={() => this.setState({ Name: e })}
              >
                <ListItemText primary={e} />
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  }

  renderButtons() {
    return (
      <div className='buttonfooter'>
        <div className='container-fluid'>
          <div className='row'>
            <ColButton
              text='Cancel'
              onClick={this.props.clickOnCancel}
            />
            <ColButton
              text='Save'
              type='submit'
              icon='fa-solid fa-save'
              disabled={!this.state.Name}
            />
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    return (
      <form onSubmit={this.clickOnSubmit}>
        <div className='container-fluid'>
          <div className='row'>{this.renderFileList()}</div>
          <div className='row'>
            {this.renderInputField('Name', 'Name', 'col', InputTypesEnum.Text, ValidityHelper.forRequiredTextField)}
          </div>

          {this.renderButtons()}
        </div>
      </form>
    );
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={this.props.windowText}
        closeOnClickOutside={false}
        maxWidth={800}
        iconName='fa-solid fa-save'
      >
        <div className=' p-1 m-1'>{this.state.loading ? <LoadingIcon loading={true} /> : this.renderContent()}</div>
        {this.state.popup}
      </OverWindow>
    );
  }
}

export default SaveJsonDataWindow;
